export default "__VITE_ASSET__BKEox_Gl__"